import { render, staticRenderFns } from "./ExcelDownColumn.vue?vue&type=template&id=b936bf5a&scoped=true&"
import script from "./ExcelDownColumn.vue?vue&type=script&lang=js&"
export * from "./ExcelDownColumn.vue?vue&type=script&lang=js&"
import style0 from "./ExcelDownColumn.vue?vue&type=style&index=0&id=b936bf5a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b936bf5a",
  null
  
)

export default component.exports